import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  TextField,
  Button,
  Switch,
  CircularProgress,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useSnackbar } from "notistack";
import { set_general_review_date_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { get_member_program_detail } from "src/DAL/Programme/Programme";

export default function ReviewsDateMember({
  programme,
  isClosePop = () => {},
  member_id,
}) {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(true);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [programDate, setProgramDate] = useState(null);
  const [memberDate, setMemberDate] = useState(null);

  const [filterData, setFilterData] = useState({
    general_review_date: null,
    apply_to_all_users: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsFormLoading(true);

    const postData = {
      general_review_date: filterData.general_review_date,
      use_individual_review_date: filterData.apply_to_all_users,
      memberId: member_id,
    };

    const result = await set_general_review_date_api(
      postData,
      programme._id,
      "member",
    );

    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      isClosePop(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }

    setIsFormLoading(false);
  };

  const getProgrammeDetail = async () => {
    const result = await get_member_program_detail(member_id, programme?._id);

    if (result.code === 200) {
      const find_program = result?.member?.program.find(
        (prog) => prog._id === programme?._id,
      );

      const programReviewDate = result?.program?.review_settings
        ?.general_review_date
        ? new Date(result.program.review_settings.general_review_date)
        : null;

      const memberReviewDate = find_program?.review_date
        ? new Date(find_program.review_date)
        : programReviewDate;

      setProgramDate(programReviewDate);
      setMemberDate(memberReviewDate);

      setFilterData({
        apply_to_all_users: find_program?.use_individual_review_date || false,
        general_review_date: memberReviewDate,
      });

      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleToggle = (value) => {
    setFilterData((prev) => ({
      ...prev,
      apply_to_all_users: value,
      general_review_date: value ? memberDate : programDate,
    }));
  };

  useEffect(() => {
    getProgrammeDetail();
  }, [programme, member_id]);

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center py-5">
          <CircularProgress />
        </div>
      ) : (
        <>
          <p className="text-muted mt-2">
            By default, the programme's review date (if set) applies to the
            member. Enable the Custom Review Date switch to set a
            member-specific review date. (Disabling the custom review date will
            switch back to the programme review date.)
          </p>

          <FormControlLabel
            control={
              <Switch
                checked={filterData.apply_to_all_users}
                onChange={(e) => handleToggle(e.target.checked)}
              />
            }
            label="Custom Review Date"
          />

          <div className="my-3">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Review Date"
                className="w-100"
                value={filterData.general_review_date}
                onChange={(newValue) => {
                  setMemberDate(newValue);
                  setFilterData((prev) => ({
                    ...prev,
                    general_review_date: newValue,
                  }));
                }}
                disablePast
                disabled={!filterData.apply_to_all_users}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </div>

          <div className="text-end">
            <Button
              onClick={handleSubmit}
              disabled={isLoading || isFormLoading}
              variant="contained"
            >
              {isFormLoading ? "Loading..." : "Submit"}
            </Button>
          </div>
        </>
      )}
    </>
  );
}
